var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weatherBox"},[_c('iframe',{staticClass:"iframeClass",attrs:{"src":"https://weather.haishangxian.net"}})])
}]

export { render, staticRenderFns }